import { Badge } from './Badge';

export function SettingsList({ children, className = '' }) {
  return <ul className={`space-y-2 ${className}`}>{children}</ul>;
}

/** Row matching More menu style: icon | title + subtitle | trailing action */
export function SettingsItem({
  icon: Icon,
  title,
  subtitle,
  action,
  onClick,
  className = '',
}) {
  const Tag = onClick ? 'button' : 'div';
  const hasAction = Boolean(action);

  return (
    <li>
      <Tag
        type={onClick ? 'button' : undefined}
        onClick={onClick}
        className={`flex w-full gap-3 rounded-xl border border-border bg-card px-4 py-3.5 text-left shadow-card ${
          hasAction
            ? 'flex-col items-stretch sm:flex-row sm:items-center'
            : 'flex-row items-center'
        } ${onClick ? 'transition-colors hover:bg-surface active:bg-surface' : ''} ${className}`}
      >
        <span className="flex min-w-0 flex-1 items-center gap-3">
          {Icon && (
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-light text-primary">
              <Icon className="h-5 w-5" />
            </span>
          )}
          <span className="min-w-0 flex-1">
            <span className="label-wrap block text-sm font-medium text-text">{title}</span>
            {subtitle && (
              <span className="label-wrap block text-sm text-muted mt-0.5">{subtitle}</span>
            )}
          </span>
        </span>
        {action && (
          <span className="w-full shrink-0 sm:w-auto sm:pl-0 flex justify-end [&_button]:w-full [&_button]:sm:w-auto">
            {action}
          </span>
        )}
      </Tag>
    </li>
  );
}

export function SettingsStatGrid({ items }) {
  return (
    <li>
      <div className="rounded-xl border border-border bg-card px-4 py-4 shadow-card">
        <div className="grid grid-cols-2 gap-x-4 gap-y-3 sm:grid-cols-4">
          {items.map(({ label, value }) => (
            <div key={label} className="min-w-0">
              <p className="label-wrap text-xs font-medium leading-snug text-muted">{label}</p>
              <p className="mt-1 text-xl font-semibold tabular-nums text-text break-words">{value}</p>
            </div>
          ))}
        </div>
      </div>
    </li>
  );
}

export function StatusBadge({ online, labels }) {
  return (
    <Badge variant={online ? 'success' : 'warning'} className="whitespace-nowrap max-w-[7rem] sm:max-w-none truncate">
      {online ? labels.apiOnline : labels.apiOffline}
    </Badge>
  );
}
